var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgModerationError = function SvgModerationError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon material-error-outline",
    d: "M19.35 27.95h4.3v4.3h-4.3zm0-17.2h4.3v12.9h-4.3zM21.479 0A21.5 21.5 0 1043 21.5 21.489 21.489 0 0021.479 0zm.021 38.7a17.2 17.2 0 1117.2-17.2 17.2 17.2 0 01-17.2 17.2z",
    fill: "#e02020"
  })));
};
export default SvgModerationError;